import axiosInstance from '../RestClient';

const BASE_URI = '/import';

// Excel importer API. The file is parsed in the browser; only JSON rows travel.
class ImportService {
	async getSchemas() {
		const response = await axiosInstance.get(`${BASE_URI}/schemas`);
		return response;
	}

	// body: { rows: [{ rowNumber, values }], links, options }
	async validate(entity, body) {
		const response = await axiosInstance.post(`${BASE_URI}/${entity}/validate`, body);
		return response;
	}

	// body: { create: [{ rowNumber, values, allowDuplicate }], updates: [{ rowNumber, id, changes, expected }], links, options }
	async commit(entity, body) {
		const response = await axiosInstance.post(`${BASE_URI}/${entity}/commit`, body);
		return response;
	}
}

export default new ImportService();
